import { Button } from "@design-lab/shared/ui";
import { Tooltip, TooltipTrigger } from "@design-lab/shared/ui/design-system/Tooltip";
import { Info } from "lucide-react";
import { useState } from "react";

export type PlacementControlTooltipProps = {
  isDesktop: boolean;
};

export function PlacementControlTooltip({ isDesktop }: PlacementControlTooltipProps) {
  const [isHintOpen, setIsHintOpen] = useState(false);

  return (
    <TooltipTrigger isOpen={isHintOpen} onOpenChange={setIsHintOpen} delay={300}>
      <Button
        data-testid="placement-control-tooltip-button"
        variant="icon"
        size="icon_xs"
        aria-label="Placement information"
        onPress={() => setIsHintOpen(true)}
      >
        <Info className="size-4 text-gray-600" />
      </Button>
      <Tooltip
        className="w-[315px] bg-blue-700 p-3 text-sm lg:w-fit lg:max-w-[430px]"
        arrowClassName="fill-blue-700"
        placement={isDesktop ? "bottom start" : "top"}
        crossOffset={isDesktop ? -10 : 0}
        offset={10}
        onClose={!isDesktop ? () => setIsHintOpen(false) : undefined}
      >
        <p className="text-wrap">
          Design is auto-centered in this area. Fixed placement ensures consistent quality for every
          order.
        </p>
      </Tooltip>
    </TooltipTrigger>
  );
}
